import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";
import { SowConfirmationInputSchema } from "@remi/types/scopeOfWorkType";

export const IntroCallCompletedTaskAttemptSchema = SowConfirmationInputSchema.extend({
  type: z.literal(TaskType.INTRO_CALL_COMPLETED),
});

export type IntroCallCompletedTaskAttempt = z.infer<typeof IntroCallCompletedTaskAttemptSchema>;
